/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DataCatalogSummaryStatsDto } from '../models/DataCatalogSummaryStatsDto';
import type { DataQualityRuleSummaryDto } from '../models/DataQualityRuleSummaryDto';
import type { DataStackSummaryDto } from '../models/DataStackSummaryDto';
import type { IncidentHeatMapDto } from '../models/IncidentHeatMapDto';
import type { IncidentSummaryDto } from '../models/IncidentSummaryDto';
import type { IncidentTimeSeriesStatusDto } from '../models/IncidentTimeSeriesStatusDto';
import type { MonitorCoverageStatsDto } from '../models/MonitorCoverageStatsDto';
import type { RuleTemplateCategoryCountSummaryDto } from '../models/RuleTemplateCategoryCountSummaryDto';
import type { StatsFilterDto } from '../models/StatsFilterDto';
import type { TableUptimeStatsDto } from '../models/TableUptimeStatsDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class StatisticsService {

    /**
     * Fetch data catalog summary
     * @returns DataCatalogSummaryStatsDto Successfully fetched data catalog summary
     * @throws ApiError
     */
    public static getDataCatalogSummary({
        domain,
        tag,
    }: {
        /**
         * Domain used for stats
         */
        domain?: string,
        /**
         * UUIDs of Tags used for stats
         */
        tag?: Array<string>,
    }): CancelablePromise<DataCatalogSummaryStatsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/statistics/data-catalog-summary',
            query: {
                'domain': domain,
                'tag': tag,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Fetch data stack info
     * @returns DataStackSummaryDto Successfully fetch data stack info
     * @throws ApiError
     */
    public static getDataStack({
        domain,
        tag,
    }: {
        /**
         * Domain used for stats
         */
        domain?: string,
        /**
         * UUIDs of Tags used for stats
         */
        tag?: Array<string>,
    }): CancelablePromise<DataStackSummaryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/statistics/data-stack',
            query: {
                'domain': domain,
                'tag': tag,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Fetch available filters for statistics
     * @returns StatsFilterDto Successfully fetch filters
     * @throws ApiError
     */
    public static getStatsFilters({
        domainId,
    }: {
        domainId?: Array<string>,
    }): CancelablePromise<StatsFilterDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/statistics/filters',
            query: {
                'domainId': domainId,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Fetch incidents heatmap
     * @returns IncidentHeatMapDto Successfully fetch incidents heatmap
     * @throws ApiError
     */
    public static getIncidentsHeatmap({
        historyDays = 90,
        domain,
        tag,
    }: {
        /**
         * Historical depth for stats
         */
        historyDays?: number,
        /**
         * Domain used for stats
         */
        domain?: string,
        /**
         * UUIDs of Tags used for stats
         */
        tag?: Array<string>,
    }): CancelablePromise<IncidentHeatMapDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/statistics/incidents-heatmap',
            query: {
                'historyDays': historyDays,
                'domain': domain,
                'tag': tag,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Fetch incidents summary
     * @returns IncidentSummaryDto Successfully fetch incidents summary
     * @throws ApiError
     */
    public static getIncidentsSummary({
        domain,
        tag,
    }: {
        /**
         * Domain used for stats
         */
        domain?: string,
        /**
         * UUIDs of Tags used for stats
         */
        tag?: Array<string>,
    }): CancelablePromise<IncidentSummaryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/statistics/incidents-summary',
            query: {
                'domain': domain,
                'tag': tag,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Fetch incidents time series
     * @returns IncidentTimeSeriesStatusDto Successfully fetch incidents time series
     * @throws ApiError
     */
    public static getIncidentsTimeSeries({
        historyDays = 90,
        domain,
        tag,
    }: {
        /**
         * Historical depth for stats
         */
        historyDays?: number,
        /**
         * Domain used for stats
         */
        domain?: string,
        /**
         * UUIDs of Tags used for stats
         */
        tag?: Array<string>,
    }): CancelablePromise<IncidentTimeSeriesStatusDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/statistics/incidents-time-series',
            query: {
                'historyDays': historyDays,
                'domain': domain,
                'tag': tag,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Fetch monitor coverage
     * @returns MonitorCoverageStatsDto Successfully fetched monitor coverage
     * @throws ApiError
     */
    public static getMonitorCoverage({
        domain,
        tag,
    }: {
        /**
         * Domain used for stats
         */
        domain?: string,
        /**
         * UUIDs of Tags used for stats
         */
        tag?: Array<string>,
    }): CancelablePromise<MonitorCoverageStatsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/statistics/monitor-coverage',
            query: {
                'domain': domain,
                'tag': tag,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Fetch rules summary
     * @returns DataQualityRuleSummaryDto Successfully fetch rules summary
     * @throws ApiError
     */
    public static getRulesSummary({
        domain,
        tag,
    }: {
        /**
         * Domain used for stats
         */
        domain?: string,
        /**
         * UUIDs of Tags used for stats
         */
        tag?: Array<string>,
    }): CancelablePromise<DataQualityRuleSummaryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/statistics/rules-summary',
            query: {
                'domain': domain,
                'tag': tag,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Fetch rules types summary
     * @returns RuleTemplateCategoryCountSummaryDto Successfully fetched rules types summary
     * @throws ApiError
     */
    public static getRulesTypesSummary({
        domain,
        tag,
    }: {
        /**
         * Domain used for stats
         */
        domain?: string,
        /**
         * UUIDs of Tags used for stats
         */
        tag?: Array<string>,
    }): CancelablePromise<RuleTemplateCategoryCountSummaryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/statistics/rules-types-summary',
            query: {
                'domain': domain,
                'tag': tag,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Fetch table uptime
     * @returns TableUptimeStatsDto Successfully fetched table uptime
     * @throws ApiError
     */
    public static getTableUptime({
        ruleTemplateNames,
        historyDays = 90,
        domain,
        tag,
    }: {
        /**
         * Rule template names used for stats
         */
        ruleTemplateNames?: Array<'COMPLETENESS' | 'DUPLICATES' | 'FRESHNESS' | 'SCHEMA_CHANGE' | 'METADATA_FRESHNESS' | 'NUMERICAL_TRANSFORMATION' | 'INTERLINKED_METRICS' | 'CUSTOM_METRICS' | 'DISTRIBUTION' | 'UNIQUE' | 'REFERENTIAL_INTEGRITY' | 'NOT_IN_LIST' | 'COUNT_DUPLICATE' | 'COUNT_NULL_ROWS' | 'RANGE' | 'IS_EMAIL' | 'IS_PHONE_NUMBER' | 'IS_UUID' | 'MATCHES_REGEX' | 'NO_CODE' | 'SQL_CONDITION' | 'SQL' | 'DBT' | '__OBSOLETE__COMPLETENESS_STATIC' | '__OBSOLETE__STATIC_COUNT_DUPLICATE' | '__OBSOLETE__DUPLICATE' | '__OBSOLETE__NULL' | '__OBSOLETE__PERCENTAGE_NULL_STATIC' | '__OBSOLETE__AVERAGE' | '__OBSOLETE__COUNT' | '__OBSOLETE__QUANTILE' | '__OBSOLETE__SUM' | '__OBSOLETE__STANDARD_DEVIATION' | '__OBSOLETE__VARIANCE' | '__OBSOLETE__PERCENTAGE_NULL_ROWS' | '__OBSOLETE__PERCENTAGE_DUPLICATES'>,
        /**
         * Historical depth for stats
         */
        historyDays?: number,
        /**
         * Domain used for stats
         */
        domain?: string,
        /**
         * UUIDs of Tags used for stats
         */
        tag?: Array<string>,
    }): CancelablePromise<TableUptimeStatsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/statistics/table-uptime',
            query: {
                'ruleTemplateNames': ruleTemplateNames,
                'historyDays': historyDays,
                'domain': domain,
                'tag': tag,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

}
